var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSelectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C11.7664 16.0004 11.5399 15.9191 11.36 15.77L6.36003 11.77C6.15581 11.6002 6.02739 11.3563 6.00301 11.0919C5.97863 10.8275 6.06029 10.5642 6.23003 10.36C6.39977 10.1558 6.64368 10.0273 6.90811 10.0029C7.17253 9.97857 7.43581 10.0602 7.64003 10.23L12 13.71L16.36 10.39C16.4623 10.3069 16.58 10.2449 16.7064 10.2074C16.8327 10.17 16.9652 10.1579 17.0962 10.1719C17.2272 10.1858 17.3542 10.2255 17.4699 10.2887C17.5855 10.3518 17.6875 10.4372 17.77 10.54C17.8616 10.6428 17.931 10.7634 17.9738 10.8943C18.0166 11.0252 18.0319 11.1635 18.0187 11.3005C18.0056 11.4376 17.9643 11.5705 17.8974 11.6908C17.8305 11.8112 17.7395 11.9164 17.63 12L12.63 15.83C12.4449 15.9555 12.2231 16.0153 12 16Z",
    fill: "#0E103B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelectIcon);
export default __webpack_public_path__ + "static/media/arrow-select-icon.cf6c270acdd6fd2c6393b0bd1c5ebf5f.svg";
export { ForwardRef as ReactComponent };